import { miscApi, downApi } from 'yxt-biz-pc/packages/api';

export const checkMiliStartStatus = id => {
  return miscApi.get(`/mili/start/status?id=${id}`);
};

export const saveMiliStartStatus = data => {
  return miscApi.post('/mili/start/status', data);
};

export const getMiliUrl = type => {
  return miscApi.get(
    `/version?orgId=00000000-0000-0000-0000-000000000000&type=${type}`
  );
};

export const getDownStatus = id => {
  return downApi.get(`/info/dlcInfo?id=${id}`);
};
